import React, { useState, useRef, useEffect } from 'react';
import { useTranslation } from 'react-i18next';

const CurrencyPopover = ({ isOpen, onClose, onSelect, position, selectedCurrency }) => {
  const { t } = useTranslation();
  const [hoveredIndex, setHoveredIndex] = useState(-1);
  const popoverRef = useRef(null);

  const currencies = [
    { id: 'all', name: t('transactions.currencyPopover.allCurrencies'), symbol: 'ALL' },
    { id: 'USDT-TRC20', name: t('transactions.currencyPopover.usdtTrc20'), symbol: 'USDT' },
    { id: 'USDT-ERC20', name: t('transactions.currencyPopover.usdtErc20'), symbol: 'USDT' },
    // { id: 'USDC-ERC20', name: 'USDC ERC20', symbol: 'USDC' },
    // { id: 'BTC', name: 'Bitcoin', symbol: 'BTC' },
    // { id: 'ETH', name: 'Ethereum', symbol: 'ETH' },
  ];

  // Close popover when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (popoverRef.current && !popoverRef.current.contains(event.target)) {
        onClose();
      }
    };

    if (isOpen) {
      document.addEventListener('mousedown', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isOpen, onClose]);

  const handleCurrencySelect = (currency) => {
    onSelect(currency);
    onClose();
  };

  if (!isOpen) return null;

  return (
    <div
      ref={popoverRef}
      className="fixed z-50 bg-white rounded-lg shadow-lg border border-gray-200 py-2 min-w-[200px]"
      style={{
        top: position?.top || 0,
        left: position?.left || 0,
      }}
    >
      {currencies.map((currency, index) => (
        <div
          key={currency.id}
          className={`px-4 py-3 cursor-pointer transition-colors ${
            selectedCurrency?.id === currency.id
              ? 'bg-gray-100 text-gray-900'
              : hoveredIndex === index
              ? 'bg-gray-50 text-gray-900'
              : 'text-gray-700 hover:bg-gray-50'
          }`}
          style={{borderRadius:"10px", margin:"4px"}}
          onMouseEnter={() => setHoveredIndex(index)}
          onMouseLeave={() => setHoveredIndex(-1)}
          onClick={() => handleCurrencySelect(currency)}
        >
          <div className="flex items-center justify-between">
            <span className="text-sm font-medium">{currency.name}</span>
            {/* <span className="text-xs text-gray-500">{currency.symbol}</span> */}
          </div>
        </div>
      ))}
    </div>
  );
};

export default CurrencyPopover;
